import React from 'react'
import './editPageLeft.css'
import CustomButton from './button'
import { Popover } from 'antd';


class EditPadLeft extends React.Component {
    constructor(props) {
        super(props)
    }

    showFileSearch = (e)=> {
        this.props.showFileSearch(e);
    };

    showArticlePad = (e) => {
        this.props.showArticle(e);
    };

    showMoudleFrame = (e) => {
        this.props.showMoudleFrame(e)
    }

    showMoban = (e) => {
        this.props.showMoban(e)
    }

    jumpToPrc = (e) => {
        window.open('http://prc.zhixingwrite.com/?token=' + localStorage.getItem('loginusertoken'));
        //window.location.href = 'http://xyadmin/';//'http://prc.zhixingwrite.com/';
    }

    jumpToLvPrc = (e) => {
        window.open('http://lvprc.zhixingwrite.com/?token=' + localStorage.getItem('loginusertoken'));
    }

    jumpToGwyPrc = (e) => {
        window.open('http://gwyprc.zhixingwrite.com/?token=' + localStorage.getItem('loginusertoken'));
    }


    render() {
        return (
            <div className='leftPage'>
                <CustomButton type='div_style file' higthLight='false' showFileSearch={this.showFileSearch} />
                <CustomButton type='div_style article' higthLight='false' showArticle={this.showArticlePad} />
                <CustomButton type='div_style file moban' higthLight='false' showFileSearch={this.showMoban} />
                <CustomButton type='div_style file fenxi' higthLight='false' showFileSearch={this.showMoudleFrame} />
                <Popover placement="right"
                    title={<span>练习</span>}
                    content={
                    <div>
                        <p><a onClick={this.jumpToPrc}>魔鬼训练营</a></p>
                        <p><a onClick={this.jumpToLvPrc}>绿云练习</a></p>
                        <p><a onClick={this.jumpToGwyPrc}>公务员练习</a></p>
                    </div>}
                trigger="hover">
                <div className='div_style file lianxi'></div>
                </Popover>
            </div>
        )
    }
}

export default EditPadLeft;
